import { render } from "./ButtonAddInscription.vue?vue&type=template&id=5e3a8510&scoped=true"
import script from "./ButtonAddInscription.vue?vue&type=script&lang=js"
export * from "./ButtonAddInscription.vue?vue&type=script&lang=js"

import "./ButtonAddInscription.vue?vue&type=style&index=0&id=5e3a8510&scoped=true&lang=css"

import exportComponent from "D:\\Downloads\\nm_sportips-inscriptions-main\\nm_sportips-inscriptions-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e3a8510"]])

export default __exports__